import script from "./Navigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigation.vue?vue&type=script&lang=ts&setup=true"

import "./Navigation.vue?vue&type=style&index=0&id=68824050&lang=css"

const __exports__ = script;

export default __exports__